// import { AppInsightsService } from "../_services/logging";

import { FeatureStorage } from "../../_services/storage";
import LabelHelper from "../_helpers/dev-express/label-helper";
import { mapGetters } from "vuex";
// eslint-disable-next-line no-unused-vars
import {
  getFactorByCode,
  getDecimalFormatByCode,
  getDecimalFormatByName,
} from "../../_store/helpers";
import validationEngine from "devextreme/ui/validation_engine";
// MOVE GLOBAL - MOVED
import BrowserHelper from "../../_helpers/browser/browser-helper";
let browserHelper = new BrowserHelper();

import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { GridReportService } from "../../_services/api/reports/grid-report.service";

import Form from "devextreme/ui/form";

export default {
  props: { title: String, isXSmall: Boolean, isLarge: Boolean },
  data() {
    // s
    return {
      baseView: { page: "", mode: "", id: "", tab: "", query: "", tempId: "" },
      selectedViewType: undefined,
      // MOVE GLOBAL - MOVED
      isTablet: false,
      ignoreRouteChangeConfirmation: false,
      key: 0,
      formsConfig: {
        colCountByScreen: {
          xs: 1,
          sm: 2,
          md: 3,
          lg: 3,
        },
        splitViewColCountByScreen: {
          xs: 1,
          sm: 1,
          md: 1,
          lg: 1,
        },
        validationSummaryVisible: false,
        serverValidationSummaryVisible: false,
        customValidationSummaryVisible: false,
        loadingVisible: false,
        validationGroup: "formsData",
        labelPosition: "left",
        items: [],
        serverItems: [],
        editableOption: true,
        reviewOption: true,
        popupAlertVisible: false,
        popupAlertMessage: "",
        validatingForm: false,
        popupAuditVisible: false,
        auditModel: {
          createdBy: "",
          dateCreated: "",
          changedBy: "",
          dateChanged: "",
        },
        dataGridForNoData: undefined,
        gridNoDataRecall: this.addGridNoResults,
      },
      selectedIndex: 0,
      loadingCompleted: false,
      companyDefaults: {
        currencyCode: undefined,
      },
      showFilterLeftContainer: true,
      showFilterRightContainer: false,
      sideBarTabs: [
        {
          id: 0,
          text: "Filters",
        },
      ],
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showFilterRightContainer = !this.showFilterRightContainer;
            var item = document.getElementById("filter-btn");
            item.classList.remove("dx-state-invisible");

            setTimeout(() => {
              this.reSizeGrid();
            }, 50);
          },
        },
      },
      filterFormHeight: "auto",
      isExporting: false,
      beforeExportColumns: [],
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleRouteChange",
    },
    isXSmall: {
      handler: function (value) {
        this.formsConfig.labelPosition = value ? "top" : "left";
      },
    },
    selectedViewType() {
      this.showLoading(true);
      this.loadingCompleted = false;
      this.getReportData(this.selectedViewType, this.advanceFilterArray);
    },
  },
  computed: {
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({
      isAdvanceFilterApplied: "dataContext/getAdvanceFilterApplied",
    }),
    ...mapGetters({ ignoreRouteChange: "ui/getIgnoreRouteChange" }),
    ExtendedReadOnly() {
      return true;
      // return this.baseView.mode == "review";
    },
    pageKey() {
      return this.baseView.mode + this.key;
    },
  },
  async created() {
    this.$store.dispatch("dataContext/setAdvanceFilterApplied", false);
    // MOVE GLOBAL - MOVED
    this.isTablet = this.baseView.query.t
      ? true
      : browserHelper.tablet
      ? true
      : false;
  },
  async beforeRouteLeave(to, from, next) {
    if (this.baseView.mode == "create" || this.baseView.mode == "edit") {
      if (this.ignoreRouteChangeConfirmation || this.ignoreRouteChange) {
        this.ignoreRouteChangeConfirmation = false;
        next();
      } else {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          next();
        } else {
          next(false);
        }
      }
    } else next();
  },
  methods: {
    reSizeGrid() {
      if (!this.formsConfig.dataGridForNoData) return;
      var e = this.formsConfig.dataGridForNoData;

      e.component.beginUpdate();
      e.component.updateDimensions();
      e.component.endUpdate();
      this.formsConfig.gridNoDataRecall(this.formsConfig.dataGridForNoData);
    },
    async getReportData(url, filterCollection) {
      // if (this.ledgerType == "details") await this.setSubCodeLabel();
      let ds = GridReportService.dataSourceConfig("api/" + url, {
        count: true,
        filter: filterCollection,
      });
      await ds.load();
      this.dataSourceConfig = ds.items();

      // this.dataSourceConfig = ds.items();
      this.showLoading(false);
      this.loadingCompleted = true;

      // if (this.ledgerType == "account") {
      //   this.dataSourceConfig.forEach((element) => {
      //     this.ledgerTitles.accountTitle =
      //       element.AccountCode + " - " + element.AccountDescription;
      //     return;
      //   });
      // } else if (this.ledgerType == "details") {
      //   this.dataSourceConfig.forEach((element) => {
      //     this.ledgerTitles.detailsTitle = element.TransactionTypeDescription;
      //     return;
      //   });
      //   this.ledgerTitles.accountTitle = JSON.parse(
      //     this.baseView.query.account_title
      //   );
      // }
      // this.ledgerTitles.summaryTitle =
      //   this.model.FiscalMonth.toLowerCase() + " " + this.model.FiscalYear;
    },
    // end validations
    validateFormConfig(form) {
      this.validatingForm = true;
      // this.refreshView();
      form.repaint();

      validationEngine.validateGroup(this.formsConfig.validationGroup);
      this.validatingForm = false;
      // this.refreshView();
      form.repaint();
    },

    // eslint-disable-next-line no-unused-vars
    handleRouteChange(to, from) {
      // eslint-disable-next-line no-console
      // this.$logger.debug(to, from);
      this.$logger.debug("loaded ", this.baseView.mode);
      this.$logger.info("This message is from new Logger");
      this.baseView.view = "";
      this.baseView.mode = "";
      this.baseView.id = "";
      this.baseView.tab = "";
      this.baseView.query = "";
      var urlTokens = to.path.split("/");
      // var urlTokens = this.$router.currentRoute.path.split("/");
      this.$logger.debug("UrlTokens", urlTokens);

      this.baseView.query = to.query;

      if (urlTokens.length > 1) {
        this.baseView.view = urlTokens[1];
      }

      // this.$logger.trackEventOpenScreen(this.baseView.view);

      // this pattern only has => base/Page/:id
      if (urlTokens.length == 2) {
        this.baseView.mode = "review";
      } else if (urlTokens.length == 3 && urlTokens[2] != "create") {
        if (urlTokens[2] == "review" || urlTokens[2] == "edit") {
          this.baseView.mode = urlTokens[2];
        } else {
          this.baseView.id = urlTokens[2];
          this.baseView.mode = "review";
        }
      } else {
        if (urlTokens.length > 2) {
          if (urlTokens[1] == "report") {
            this.baseView.mode = "review";
          } else {
            this.baseView.mode = urlTokens[2].toLowerCase();
          }
        }
        if (urlTokens.length > 3) {
          this.baseView.id = urlTokens[3];
        }
        if (urlTokens.length > 4) {
          this.baseView.tab = urlTokens[4].toLowerCase();
        }
      }

      if (this.baseView.mode) {
        if (
          FeatureStorage.checkPermission(
            to.meta.applicationFeatureCode,
            this.baseView.mode
          ) == false
        ) {
          // eslint-disable-next-line no-console
          // this.$logger.debug("redirect to Unauthorized from baseview!");
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            name: "unauthorized",
          });
        }
      }

      this.formsConfig.editableOption = FeatureStorage.checkPermission(
        to.meta.applicationFeatureCode,
        "edit"
      );

      this.formsConfig.createOption = FeatureStorage.checkPermission(
        to.meta.applicationFeatureCode,
        "create"
      );

      this.formsConfig.reviewOption = FeatureStorage.checkPermission(
        to.meta.applicationFeatureCode,
        "review"
      );

      this.$logger.debug("loaded 2", this.baseView.mode);
      if (this.baseView.mode != "edit") {
        this.loadingCompleted = false;
      } else {
        if (
          this.baseView.view != "despatch-order" &&
          this.baseView.view != "goods-in" &&
          this.baseView.view != "goods-return"
        ) {
          this.loadingCompleted = true;
        }
      }
    },
    refreshView() {
      this.key += 1;
      // this.baseView.query = this.$router.currentRoute.query;
    },
    setIgnoreRouteChangeConfirmation() {
      this.ignoreRouteChangeConfirmation = true;
    },
    displayAuditPopup(createdBy, dateCreated, changedBy, dateChanged) {
      this.formsConfig.popupAuditVisible = true;
      this.formsConfig.auditModel.createdBy = createdBy;
      this.formsConfig.auditModel.dateCreated = dateCreated;
      this.formsConfig.auditModel.changedBy = changedBy;
      this.formsConfig.auditModel.dateChanged = dateChanged;
    },
    displayServerError(error, genericMessage) {
      this.showLoading(false);
      this.$logger.debug("error", error);
      this.formsConfig.serverItems = [];

      if (
        error.status === 400 &&
        error.data &&
        error.data.Errors &&
        typeof error.data.Errors === "object" &&
        !Array.isArray(error.data.Errors) &&
        error.data.Errors !== null
      ) {
        // catering for Server Validation Errors display
        const errorsArray = [];
        var data = error.data;
        for (const key in data.Errors) {
          if (data.Errors.hasOwnProperty(key)) {
            // check if this is an array data.Errors[key]
            if (Array.isArray(data.Errors[key])) {
              errorsArray.push(...data.Errors[key]);
            } else {
              errorsArray.push(data.Errors[key]);
            }
          }
        }
        this.formsConfig.serverItems.push(...errorsArray);
      } else if (error.data.value && error.data.value.length > 0) {
        this.formsConfig.serverItems.push(
          JSON.parse(error.data.value)[0].ErrorMessage
        );
      } else if (error.data && error.data.length > 0) {
        this.formsConfig.serverItems.push(error.data[0].ErrorMessage);
      } else if (error.data.error.innererror) {
        this.formsConfig.serverItems.push(error.data.error.innererror.message);
      } else if (error.data.error.message) {
        this.formsConfig.serverItems.push(
          JSON.parse(error.data.error.message)[0].ErrorMessage
        );
      } else {
        this.$notify(genericMessage, "error");
      }

      this.formsConfig.serverValidationSummaryVisible = true;
    },
    displayValidationSummary(itemArray) {
      if (itemArray) {
        this.formsConfig.items = itemArray;
      }

      if (this.formsConfig.items.length > 0)
        this.formsConfig.validationSummaryVisible = true;
    },
    addErrorMessage(message) {
      this.formsConfig.items.push(message);
    },
    addErrorMessagesFromValidationResult(validationResult) {
      this.formsConfig.items = [];
      if (validationResult.brokenRules)
        validationResult.brokenRules.forEach((x) => {
          this.$logger.debug(`validation error message:  ${x.message}`);
          this.formsConfig.items.push(x.message);
        });
    },
    customizeItem(item) {
      if (item.itemType == "simple") {
        item.editorOptions = item.editorOptions || {};

        item.editorOptions.disabled = this.validatingForm
          ? false
          : this.baseView.mode == "review";
      }
    },
    displayCustomValidationSummary() {
      this.formsConfig.customValidationSummaryVisible = true;
    },
    showLoading(show) {
      this.formsConfig.loadingVisible = show;
    },
    displayAlert(message) {
      this.formsConfig.popupAlertMessage = message;
      this.formsConfig.popupAlertVisible = true;
    },
    getFactorByCode(code) {
      return getFactorByCode(code);
    },
    getDecimalFormatByCode(code) {
      return getDecimalFormatByCode(code);
    },
    getDecimalFormatByName(name) {
      return getDecimalFormatByName(name);
    },
    addGridNoResults(e, noDataMessageOverride) {
      if (!e) return;
      setTimeout(() => {
        var data = undefined;

        if (
          noDataMessageOverride &&
          !e.component.state().searchText &&
          !this.isAdvanceFilterApplied
        ) {
          data = noDataMessageOverride.addNew;
        } else if (
          this.noDataMessage &&
          !e.component.state().searchText &&
          !this.isAdvanceFilterApplied
        ) {
          data = this.noDataMessage.addNew;
        } else
          data = {
            class: "no-data",
            title: "Uh-oh!",
            message:
              "We are struggling to find what you are looking for. Try altering your search criteria",
          };

        let masterDetails = e.element.querySelector(".dx-master-detail-row");
        let noData = e.element.querySelector(
          ".dx-datagrid-nodata:not(.dx-hidden)"
        );

        let gridContentArea = e.element.querySelector(".dx-datagrid-rowsview");

        if (noData && gridContentArea && gridContentArea.clientHeight < 265) {
          data.class = data.class + " hide";
        }

        this.formsConfig.dataGridForNoData = e;
        if (noData && masterDetails == null) {
          noData.innerHTML = `<div class="content-block home-content" ref="home-content">
        <img class="${data.class}" width="300" />
        <div class="details-div">
       <span class='oops'>${data.title}</span>
          <p class="p-details">
          ${data.message}
        </p>
        </div>
      </div>`;
        }
      }, 200);

      this.filterFormHeight =
        document.getElementsByClassName("dx-datagrid dx-gridbase-container")[0]
          .clientHeight -
        document.getElementsByClassName("dx-datagrid-header-panel")[0]
          .clientHeight -
        30;
    },
    onSelectionChanged(e, rowSelectOptions) {
      let id = e.selectedRowsData[0][rowSelectOptions.idProperty];
      this.$router.push({
        path: `/${rowSelectOptions.page}/${rowSelectOptions.mode}/${id}`,
      });
    },
    onRowClicked(e, rowSelectOptions) {
      if (e.column) if (e.column.cellTemplate == "RadioTemplate") return;

      let property = rowSelectOptions.idProperty;
      let id = e.data[property];
      this.$router
        .push({
          path: `/${rowSelectOptions.page}/${rowSelectOptions.mode}/${id}`,
        })
        .then((res) => {
          if (res)
            setTimeout(() => {
              this.reSizeGrid();
            }, 50);
        });
    },
    onContextMenuPreparing: function (e, rowSelectOptions) {
      if (e.row.rowType === "data") {
        // e.items can be undefined
        if (!e.items) e.items = [];

        // Add a custom menu item
        e.items.push(
          {
            text: "Open link in new tab",
            closeMenuOnClick: true,
            onItemClick: () => {
              setTimeout(() => {
                let id = e.row.data[rowSelectOptions.idProperty];
                window.open(
                  `${rowSelectOptions.page}/${rowSelectOptions.mode}/${id}`,
                  "_blank"
                );
              }, 25);
            },
          },
          {
            text: "Open link in new window",
            closeMenuOnClick: true,
            onItemClick: () => {
              let id = e.row.data[rowSelectOptions.idProperty];

              window.open(
                `${rowSelectOptions.page}/${rowSelectOptions.mode}/${id}`,
                "",
                "toolbar=0,location=0,scrollbars=1,statusbar=1,menubar=0,resizable=1"
              );
            },
          }
        );
      }
    },

    notifyGCSCError(msg) {
      alert("GCS ERROR - " + msg);
    },

    parseFormColumns(fields) {
      fields.forEach((currentField) => {
        // GCS-GcLabel
        if (currentField.hasOwnProperty("label")) {
          this.notifyGCSCError(
            `FormField: ${currentField.caption} must not set label`
          );
        } else {
          if (
            !currentField.hasOwnProperty("gcLabel") &&
            !currentField.hasOwnProperty("gcDynamicLabel") &&
            !currentField.gcType == "Button"
          ) {
            this.notifyGCSCError(
              `FormField: ${currentField.caption} must set gcLabel or gcDynamicLabel`
            );
          } else {
            currentField.label = currentField.gcLabel
              ? {
                  text: LabelHelper.getLabelByName(currentField.gcLabel),
                  visible: currentField.gcLabelVisible == false ? false : true,
                }
              : { text: currentField.gcDynamicLabel };

            if (currentField.labelVisible === false)
              currentField.label.visible = false;
          }
        }

        if (currentField.location)
          currentField.label.location = currentField.location;

        // Required Rule
        if (currentField.required) {
          let validationObject = {
            type: "required",
            message: `${currentField.gcLabel} is required`,
          };
          if (!currentField.hasOwnProperty("validationRules")) {
            currentField.validationRules = [validationObject];
          } else {
            currentField.validationRules.push(validationObject);
          }
        }

        if (!currentField.hasOwnProperty("gcType")) {
          // Type validation and standards
          this.notifyGCSCError(
            `FormField: ${currentField.caption} must specify gcType`
          );
        }
        if (currentField.gcType == "String") {
          currentField = this.parseTypeStringField(currentField);
        }
        if (
          currentField.hasOwnProperty("gcType") &&
          currentField.gcType.startsWith("Decimal")
        ) {
          currentField = this.parseTypeDecimalField(currentField);
        }
        if (currentField.gcType === "Date") {
          currentField = this.parseTypeDateField(currentField);
        }
        if (currentField.gcType === "Datetime") {
          currentField = this.parseTypeDatetimeField(currentField);
        }
        if (currentField.gcType == "Boolean") {
          currentField = this.parseTypeBooleanField(currentField);
        }
        if (currentField.gcType === "Button") {
          currentField = this.parseTypeButton(currentField);
        }

        // console.log('# A', currentField);

        if (!currentField.editorOptions) currentField.editorOptions = {};

        var onFocusIn = undefined;
        if (currentField.editorOptions.onFocusIn)
          onFocusIn = currentField.editorOptions.onFocusIn;
        currentField.editorOptions.onFocusIn = (e) => {
          var input = e.element.querySelector("input");
          if (input) {
            input.setAttribute(
              "autocomplete",
              "new-input-" + (e.name ? e.name : input.name)
            );
          }

          if (onFocusIn) {
            onFocusIn();
          }
        };
      });

      return fields;
    },
    gridColumnMinWidth(width) {
      // #27635 : White spacing issue after applying a filter and closing the advanced filter panel
      // return this.showFilterRightContainer ? width : width;
      return width;
    },
    parseGridColumns(gridType, columns) {
      let length = columns.length;
      // length = 1;

      let hasPrimary = false;

      for (let i = 0; i < length; i++) {
        let currentColumn = columns[i];
        // this.$logger.debug('column ', currentColumn);

        // Global
        if (!currentColumn.hasOwnProperty("allowEditing")) {
          currentColumn.allowEditing = false;
        }

        if (currentColumn.hasOwnProperty("editCellTemplate")) {
          if (!currentColumn.hasOwnProperty("cssClass"))
            currentColumn.cssClass = "gc-editor-cell";
        }

        if (!currentColumn.hasOwnProperty("dataField")) {
          currentColumn.allowFiltering = false;
        }

        // GCS-GcLabel
        if (
          // !currentColumn.hasOwnProperty("gcLabel") &&
          currentColumn.hasOwnProperty("caption")
        ) {
          this.notifyGCSCError(
            `GridColumn: ${currentColumn.caption} must not set caption`
          );
        } else {
          if (
            !currentColumn.hasOwnProperty("gcLabel") &&
            !currentColumn.hasOwnProperty("gcDynamicLabel") &&
            currentColumn.gcSubType != "Chip" &&
            currentColumn.gcSubType != "IconButton"
          ) {
            this.notifyGCSCError(
              `GridColumn: ${currentColumn.caption} must set gcLabel or gcDynamicLabel`
            );
          }
          if (currentColumn.hasOwnProperty("gcLabel")) {
            if (
              currentColumn.gcSubType != "Chip" &&
              currentColumn.gcSubType != "IconButton"
            ) {
              currentColumn.caption = LabelHelper.getLabelByName(
                currentColumn.gcLabel
              );
            }
          } else if (currentColumn.hasOwnProperty("gcDynamicLabel")) {
            currentColumn.caption = currentColumn.gcDynamicLabel;
          }
        }

        if (!currentColumn.hasOwnProperty("gcType")) {
          this.notifyGCSCError(
            `GridColumn: ${currentColumn.caption} must specify gcType`
          );
        }

        // Type validation and standards
        if (currentColumn.gcType == "String") {
          currentColumn = this.parseTypeStringColumn(currentColumn);
        }

        if (currentColumn.gcType == "Boolean") {
          currentColumn = this.parseTypeBooleanColumn(currentColumn);
        }

        if (
          currentColumn.hasOwnProperty("gcType") &&
          currentColumn.gcType.startsWith("Decimal")
        ) {
          currentColumn = this.parseTypeDecimalColumn(currentColumn);
        }

        if (
          currentColumn.hasOwnProperty("gcType") &&
          currentColumn.gcType.startsWith("DynamicDecimal")
        ) {
          currentColumn = this.parseTypeDynamicDecimalColumn(currentColumn);
        }

        if (currentColumn.gcType === "Date") {
          currentColumn = this.parseTypeDateColumn(currentColumn);
        }

        if (currentColumn.gcType === "Datetime") {
          currentColumn = this.parseTypeDatetimeColumn(currentColumn);
        }

        // Sub Type
        if (currentColumn.gcSubType == "PrimaryChildRecord") {
          hasPrimary = true;
          currentColumn = this.parseSubTypePrimaryChild(currentColumn);
        }
        if (currentColumn.gcSubType == "PrimaryRecord") {
          hasPrimary = true;
          currentColumn = this.parseSubTypePrimary(currentColumn);
        }

        if (currentColumn.gcSubType == "TransactionNo") {
          hasPrimary = true;
          currentColumn = this.parseSubTypeTransactionNo(currentColumn);
        }

        if (currentColumn.gcSubType == "PrimaryTransactionNo") {
          hasPrimary = true;
          currentColumn = this.parseSubTypePrimaryTransactionNo(currentColumn);
        }

        if (currentColumn.gcSubType == "PrimaryDate") {
          hasPrimary = true;
          currentColumn = this.parseSubTypePrimaryDate(currentColumn);
        }

        if (currentColumn.gcSubType == "RelatedRecord") {
          currentColumn = this.parseSubTypeRelatedRecord(currentColumn);
        }

        if (
          currentColumn.gcSubType == "HiddenCode" ||
          currentColumn.gcSubType == "HiddenDescription"
        ) {
          currentColumn.visible = false; // GCS-PrimaryRecordCodeHidden, PrimaryDescriptionHidden
        }

        if (currentColumn.gcSubType == "Chip") {
          currentColumn = this.parseSubTypeChip(currentColumn);
        }

        if (currentColumn.gcSubType == "EditableCheckBox") {
          currentColumn = this.parseSubTypeEditableCheckBox(currentColumn);
        }

        if (currentColumn.gcSubType == "IconButton") {
          currentColumn = this.parseSubTypeIconButton(currentColumn);
        }
      }

      if (!hasPrimary && gridType != "grouped-report") {
        this.notifyGCSCError(`Grid: needs a Primary Column specified`);
      }

      // this.$logger.debug("columns", columns);

      return columns;
    },
    parseSubTypePrimaryChild(currentColumn) {
      currentColumn.visible = true;
      // NOTE: Setting the follwing props somehow makes the editable grid to not respond on clicks
      // currentColumn.fixed = true; //GCS-PrimaryRecordFixedLeftFirstColumn
      // currentColumn.fixedPosition = "left"; //GCS-PrimaryRecordFixedLeftFirstColumn

      return currentColumn;
    },
    parseSubTypePrimary(currentColumn) {
      if (currentColumn.hasOwnProperty("width")) {
        // GCS-PrimaryRecordFixedMinWidthAutoWidth
        this.notifyGCSCError(
          `SubTypePrimary: ${currentColumn.caption} must not set width`
        );
      }

      if (currentColumn.hasOwnProperty("fixed")) {
        // GCS-PrimaryRecordFixedLeftFirstColumn
        this.notifyGCSCError(
          `SubTypePrimary: ${currentColumn.caption} must not set fixed`
        );
      }

      if (currentColumn.hasOwnProperty("fixedPosition")) {
        // GCS-PrimaryRecordFixedLeftFirstColumn
        this.notifyGCSCError(
          `SubTypePrimary: ${currentColumn.caption} must not set fixedPosition`
        );
      }

      if (!currentColumn.hasOwnProperty("sortOrder")) {
        currentColumn.sortOrder = "asc"; // GCS-PrimaryRecordSortAndColumn
      }

      if (!currentColumn.hasOwnProperty("minWidth")) {
        currentColumn.minWidth = this.gridColumnMinWidth(300); // GCS-PrimaryRecordFixedMinWidthAutoWidth
      }

      if (!currentColumn.hasOwnProperty("visible")) {
        currentColumn.visible = !this.isExporting;
      }

      currentColumn.fixed = !this.isTablet; // GCS-PrimaryRecordFixedLeftFirstColumn //HACK: Tablet scrolling doesnt worked on fixed columns
      currentColumn.fixedPosition = "left"; // GCS-PrimaryRecordFixedLeftFirstColumn
      currentColumn.allowReordering = false;
      currentColumn.allowHiding = false;

      return currentColumn;
    },

    parseSubTypeRelatedRecord(currentColumn) {
      if (!currentColumn.hasOwnProperty("cellTemplate")) {
        this.notifyGCSCError(
          `SubTypeRelatedRecord: ${currentColumn.caption} must set cellTemplate`
        );
      }

      return currentColumn;
    },

    parseSubTypePrimaryTransactionNo(currentColumn) {
      if (currentColumn.hasOwnProperty("minWidth")) {
        // GCS-PrimaryTransactionNoWidth:
        this.notifyGCSCError(
          `SubTypePrimaryTransactionNo: ${currentColumn.caption} must not set minWidth`
        );
      }

      if (currentColumn.hasOwnProperty("fixed")) {
        // GCS-PrimaryTransactionNoFixedLeftFirstColumn
        this.notifyGCSCError(
          `SubTypePrimaryTransactionNo: ${currentColumn.caption} must not set fixed`
        );
      }

      if (currentColumn.hasOwnProperty("fixedPosition")) {
        // GCS-PrimaryTransactionNoFixedLeftFirstColumn
        this.notifyGCSCError(
          `SubTypePrimaryTransactionNo: ${currentColumn.caption} must not set fixedPosition`
        );
      }

      if (!currentColumn.hasOwnProperty("sortOrder")) {
        currentColumn.sortOrder = "desc"; // GCS-PrimaryTransactionNoSortAndColumn
      }

      currentColumn.visible = true;
      currentColumn.fixed = !this.isTablet; // GCS-PrimaryTransactionNoFixedLeftFirstColumn //HACK: Tablet scrolling doesnt worked on fixed columns
      currentColumn.fixedPosition = "left"; // GCS-PrimaryTransactionNoFixedLeftFirstColumn
      currentColumn.alignment = "left"; // GCS-PrimaryTransactionNoAlignment
      currentColumn.allowReordering = false;
      currentColumn.allowHiding = false;

      return currentColumn;
    },

    parseSubTypeTransactionNo(currentColumn) {
      if (currentColumn.hasOwnProperty("fixed")) {
        // GCS-PrimaryTransactionNoFixedLeftFirstColumn
        this.notifyGCSCError(
          `SubTypePrimaryTransactionNo: ${currentColumn.caption} must not set fixed`
        );
      }

      if (currentColumn.hasOwnProperty("fixedPosition")) {
        // GCS-PrimaryTransactionNoFixedLeftFirstColumn
        this.notifyGCSCError(
          `SubTypePrimaryTransactionNo: ${currentColumn.caption} must not set fixedPosition`
        );
      }

      currentColumn.alignment = "left"; // GCS-PrimaryTransactionNoAlignment

      return currentColumn;
    },

    parseSubTypePrimaryDate(currentColumn) {
      if (currentColumn.hasOwnProperty("minWidth")) {
        // GCS-PrimaryTransactionNoWidth:
        this.notifyGCSCError(
          `SubTypePrimaryDate: ${currentColumn.caption} must not set minWidth`
        );
      }

      if (currentColumn.hasOwnProperty("fixed")) {
        // GCS-PrimaryTransactionNoFixedLeftFirstColumn
        this.notifyGCSCError(
          `SubTypePrimaryDate: ${currentColumn.caption} must not set fixed`
        );
      }

      if (currentColumn.hasOwnProperty("fixedPosition")) {
        // GCS-PrimaryTransactionNoFixedLeftFirstColumn
        this.notifyGCSCError(
          `SubTypePrimaryDate: ${currentColumn.caption} must not set fixedPosition`
        );
      }

      if (!currentColumn.hasOwnProperty("sortOrder")) {
        currentColumn.sortOrder = "desc"; // GCS-PrimaryTransactionNoSortAndColumn
      }

      currentColumn.visible = true;
      currentColumn.fixed = !this.isTablet; // GCS-PrimaryTransactionNoFixedLeftFirstColumn //HACK: Tablet scrolling doesnt worked on fixed columns
      currentColumn.fixedPosition = "left"; // GCS-PrimaryTransactionNoFixedLeftFirstColumn
      currentColumn.alignment = "left"; // GCS-PrimaryTransactionNoAlignment
      currentColumn.allowReordering = false;
      currentColumn.allowHiding = false;

      return currentColumn;
    },

    parseTypeStringColumn(currentColumn) {
      // if (currentColumn.hasOwnProperty("allowFiltering")) {
      //   this.notifyGCSCError(
      //     `TypeStringColumn: ${currentColumn.caption} must not set allowFiltering`
      //   );
      // }

      if (
        currentColumn.gcSubType != "Chip" &&
        currentColumn.gcSubType != "IconButton" &&
        currentColumn.gcSubType != "PrimaryRecord"
      ) {
        if (
          !currentColumn.hasOwnProperty("width") &&
          !currentColumn.hasOwnProperty("minWidth")
        ) {
          // GCS-RelatedRecordWidth
          // GCS-StringWidth
          this.notifyGCSCError(
            `TypeStringColumn: ${currentColumn.caption} must set width or minWidth`
          );
        }
      }

      if (currentColumn.hasOwnProperty("alignment")) {
        this.notifyGCSCError(
          `TypeStringColumn: ${currentColumn.caption} must not set alignment`
        );
      }
      if (!currentColumn.hasOwnProperty("allowFiltering")) {
        currentColumn.allowFiltering = true;
      }

      currentColumn.alignment = "left"; // GCS-StringAlignment

      return currentColumn;
    },

    parseTypeBooleanColumn(currentColumn) {
      if (!currentColumn.hasOwnProperty("allowFiltering")) {
        currentColumn.allowFiltering = false;
      }

      return currentColumn;
    },

    parseTypeDecimalColumn(currentColumn) {
      if (currentColumn.hasOwnProperty("width")) {
        // GCS-DecimalFormatWidth
        this.notifyGCSCError(
          `TypeDecimalColumn: ${currentColumn.caption} must not set width`
        );
      }

      currentColumn.format = this.getDecimalFormatByName(
        currentColumn.gcType
      ).Format; // GCS-DecimalFormat

      let property =
        currentColumn.gcType == "Decimal-TransactionNo" ||
        currentColumn.showEditorAlways
          ? "width"
          : "minWidth";

      currentColumn[property] = this.getDecimalFormatByName(
        currentColumn.gcType
      ).Width; // GCS-DecimalFormatWidth

      if (!currentColumn.hasOwnProperty("allowFiltering")) {
        currentColumn.allowFiltering = true;
      }

      currentColumn.cssClass = "decimal-no-wrap";
      if (!currentColumn.alignment) currentColumn.alignment = "right";

      if (currentColumn.setWidth) currentColumn.width = currentColumn.setWidth;
      return currentColumn;
    },

    parseTypeDynamicDecimalColumn(currentColumn) {
      if (currentColumn.hasOwnProperty("width")) {
        // GCS-DecimalFormatWidth
        this.notifyGCSCError(
          `TypeDecimalColumn: ${currentColumn.caption} must not set width`
        );
      }

      currentColumn.width = 200;
      if (!currentColumn.hasOwnProperty("allowFiltering")) {
        currentColumn.allowFiltering = true;
      }

      return currentColumn;
    },

    parseTypeDateColumn(currentColumn) {
      // GCS-DateWidth
      if (currentColumn.hasOwnProperty("width")) {
        this.notifyGCSCError(
          `TypeDateColumn: ${currentColumn.caption} must not set width`
        );
      }

      if (currentColumn.hasOwnProperty("allowFiltering")) {
        this.notifyGCSCError(
          `TypeDateColumn: ${currentColumn.caption} must not set allowFiltering`
        );
      }

      if (currentColumn.hasOwnProperty("cellTemplate")) {
        this.notifyGCSCError(
          `TypeDateColumn: ${currentColumn.caption} must not set cellTemplate [GcFriendlyDate must be retired]`
        );
      }

      currentColumn.allowFiltering = false; // GCS-DateAllowFiltering

      // GCS-DateFormat
      currentColumn.format = "dd MMM yyyy";

      // GCS-DateWidth
      currentColumn.width = 140;

      return currentColumn;
    },

    parseTypeDatetimeColumn(currentColumn) {
      // GCS-DateWidth
      if (currentColumn.hasOwnProperty("width")) {
        this.notifyGCSCError(
          `TypeDateColumn: ${currentColumn.caption} must not set width`
        );
      }

      if (currentColumn.hasOwnProperty("allowFiltering")) {
        this.notifyGCSCError(
          `TypeDateColumn: ${currentColumn.caption} must not set allowFiltering`
        );
      }

      // if (currentColumn.hasOwnProperty("cellTemplate")) {
      //   this.notifyGCSCError(
      //     `TypeDateColumn: ${currentColumn.caption} must not set cellTemplate [GcFriendlyDate must be retired]`
      //   );
      // }

      currentColumn.allowFiltering = false; // GCS-DateAllowFiltering

      // GCS-DateFormat
      currentColumn.format = "dd MMM yyyy, hh:mm:ss a";

      // GCS-DateWidth
      currentColumn.width = 200;

      return currentColumn;
    },

    parseSubTypeChip(currentColumn) {
      if (currentColumn.hasOwnProperty("width")) {
        this.notifyGCSCError(
          `SubTypeChip: ${currentColumn.caption} must not set width`
        );
      }

      if (currentColumn.hasOwnProperty("caption")) {
        this.notifyGCSCError(
          `SubTypeChip: ${currentColumn.caption} must not set caption`
        );
      }

      if (currentColumn.hasOwnProperty("fixed")) {
        // GCS-PrimaryRecordFixedLeftFirstColumn
        this.notifyGCSCError(
          `SubTypeChip: ${currentColumn.caption} must not set fixed`
        );
      }

      if (currentColumn.hasOwnProperty("fixedPosition")) {
        // GCS-PrimaryRecordFixedLeftFirstColumn
        this.notifyGCSCError(
          `SubTypeChip: ${currentColumn.caption} must not set fixedPosition`
        );
      }

      currentColumn.caption = "";
      currentColumn.width = 100; // GCS-ChipWidth
      currentColumn.allowEditing = false;
      currentColumn.allowFiltering = true;
      currentColumn.fixed = true; // GCS-ChipFixedRight //HACK: Tablet scrolling doesnt worked on fixed columns
      currentColumn.fixedPosition = "right"; // GCS-ChipFixedRight
      currentColumn.alignment = "left"; // GCS-ChipAlignment
      currentColumn.allowReordering = false;
      currentColumn.showInColumnChooser = false;

      return currentColumn;
    },
    parseSubTypeEditableCheckBox(currentColumn) {
      if (!currentColumn.hasOwnProperty("width")) {
        currentColumn.width = 100;
      }

      currentColumn.editorType = "dxCheckBox";
      currentColumn.cssClass = "gc-editor-cell";
      currentColumn.allowEditing = true;

      return currentColumn;
    },

    parseSubTypeIconButton(currentColumn) {
      if (currentColumn.hasOwnProperty("width")) {
        this.notifyGCSCError(
          `SubTypeIconButton: ${currentColumn.caption} must not set width`
        );
      }

      if (currentColumn.hasOwnProperty("caption")) {
        this.notifyGCSCError(
          `SubTypeIconButton: ${currentColumn.caption} must not set caption`
        );
      }

      if (currentColumn.hasOwnProperty("dataField")) {
        this.notifyGCSCError(
          `SubTypeIconButton: ${currentColumn.caption} must not set dataField`
        );
      }

      if (!currentColumn.hasOwnProperty("cellTemplate")) {
        this.notifyGCSCError(
          `SubTypeIconButton: ${currentColumn.caption} must set cellTemplate`
        );
      }

      currentColumn.caption = "";
      currentColumn.dataField = "";
      currentColumn.width = 50; // GCS-IconButtonWidth
      currentColumn.fixed = true; // GCS-IconButtonFixedRight //HACK: Tablet scrolling doesnt worked on fixed columns
      currentColumn.fixedPosition = "right"; // GCS-IconButtonFixedRight
      currentColumn.alignment = "left"; // GCS-IconButtonAlignment
      currentColumn.allowReordering = false;
      currentColumn.showInColumnChooser = false;

      return currentColumn;
    },

    parseTypeStringField(currentField) {
      if (!currentField.editorOptions) currentField.editorOptions = {};

      if (currentField.readOnly)
        currentField.editorOptions.readOnly = currentField.readOnly;

      if (currentField.disabled)
        currentField.editorOptions.disabled = currentField.disabled;

      if (!currentField.editorOptions.maxLength)
        currentField.editorOptions.maxLength = 200;

      return currentField;
    },

    parseTypeDecimalField(currentField) {
      currentField.editorType = "dxNumberBox";
      if (!currentField.editorOptions) currentField.editorOptions = {};

      if (currentField.readOnly)
        currentField.editorOptions.readOnly = currentField.readOnly;

      if (currentField.disabled)
        currentField.editorOptions.disabled = currentField.disabled;

      currentField.editorOptions.maxLength = 200;

      currentField.editorOptions.format = this.getDecimalFormatByName(
        currentField.gcType
      ).Format;

      return currentField;
    },
    parseTypeDateField(currentField) {
      currentField.editorType = "dxDateBox";
      if (!currentField.editorOptions) currentField.editorOptions = {};
      currentField.editorOptions.displayFormat = "dd MMM yyyy";

      return currentField;
    },
    parseTypeDatetimeField(currentField) {
      currentField.editorType = "dxDateBox";
      if (!currentField.editorOptions) currentField.editorOptions = {};
      currentField.editorOptions.type = "datetime";
      currentField.editorOptions.displayFormat = "dd MMM yyyy, hh:mm:ss a";

      return currentField;
    },
    parseTypeBooleanField(currentField) {
      currentField.editorType = "dxSwitch";

      return currentField;
    },
    parseTypeButton(currentField) {
      return currentField;
    },

    onGridToExcelExporting(e, fileName, originalColumn) {
      if (e.component.getDataSource().totalCount() == 0) {
        e.cancel = true;
        this.displayValidationSummary([
          "There is no data to download. Please generate report data by selecting your report critiera and applying them.",
        ]);
        return;
      }

      let visibleColumns = e.component.getVisibleColumns();
      originalColumn.forEach((element) => {
        let index = undefined;

        if (element.cellTemplate)
          index = visibleColumns.findIndex(
            (x) =>
              x.dataField == element.dataField &&
              x.cellTemplate == element.cellTemplate
          );
        else
          index = visibleColumns.findIndex(
            (x) => x.dataField == element.dataField && !x.cellTemplate
          );
        if (index > -1) {
          // element.visible = true;
          if (visibleColumns[index].cellTemplate) {
            if (visibleColumns[index].cellTemplate == element.cellTemplate)
              element.visible = true;
            else element.visible = false;
          } else element.visible = true;
        } else {
          element.visible = false;
        }
      });

      let grid = e.component.instance();
      if (e.component.getDataSource().totalCount() > 30000) {
        e.cancel = true;
        this.displayValidationSummary([
          "Export is too large, please filter the list and try exporting again.",
        ]);
      } else {
        e.cancel = true;

        this.beforeExportColumns = JSON.stringify([...originalColumn]);
        let columChange = [...originalColumn];
        e.component.beginUpdate();
        var columnNames = [];

        for (let index = 0; index < columChange.length; index++) {
          const element = columChange[index];
          if (element.gcExport) {
            if (Array.isArray(element.gcExport)) {
              if (element.visible) {
                element.gcExport.forEach((exportColumn, count) => {
                  let hIndex = columChange.findIndex(
                    (x) => x.dataField == exportColumn && !x.cellTemplate
                  );

                  if (hIndex > -1) {
                    if (!columChange[hIndex].visible) {
                      columChange[hIndex].visible = true;
                      columnNames.push(exportColumn);
                    }
                    columChange[index].allowExporting = false;
                    columChange.move(hIndex, index + count + 1);
                  }
                });
              }
            }
          } else {
            // console.log('Export :',element);
            // if(element.gcType == "Datetime"){
            //   // console.log('e.component :',e.component);
            //   e.component.columnOption(element.dataField, "format", "shortDate");
            //   console.log('Export 2:',element);
            // }

            if (
              element.dataField == "Inactive" ||
              element.dataField == "FriendlyActive"
            ) {
              // e.component.columnOption(element.dataField, "caption", "Status");
              columChange[index].caption = "Status";
              columnNames.push(element.dataField);
            }
          }
        }

        // console.log('columnNames ', columnNames);
        e.component.option("columns", columChange);

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        exportDataGrid({
          component: e.component,
          worksheet: worksheet,
          customizeCell: (options) => {
            const excelCell = options.excelCell;
            // excelCell.font = { name: "Arial", size: 12 };
            // excelCell.alignment = { horizontal: "left" };

            if (options.gridCell.rowType === "data") {
              if (options.gridCell.column.dataField == "Inactive") {
                if (options.gridCell.value == "N" || !options.gridCell.value)
                  excelCell.value = "Active";
                else if (
                  options.gridCell.value == "Y" ||
                  options.gridCell.value
                )
                  excelCell.value = "Inactive";
              } else if (options.gridCell.column.dataType == "datetime") {
                excelCell.value =
                  options.gridCell.value.dateWithOffset().toShortDateString() +
                  ", " +
                  options.gridCell.value.dateWithOffset().toShortTimeString();
              } else if (
                options.gridCell.column.dataType == "date" &&
                options.gridCell.column.format == "dd MMM yyyy"
              ) {
                excelCell.value = new Date(
                  options.gridCell.value
                ).toShortDateString();
              }
            }

            if (options.gridCell.column.format) {
              if (options.gridCell.value) {
                var pattern = /[%]/g;
                if (pattern.test(options.gridCell.column.format)) {
                  excelCell.value = options.gridCell.value.toFixed(2) + " %";
                } else {
                  excelCell.numFmt = options.gridCell.column.format;
                }

                if (options.gridCell.value <= 0) {
                  excelCell.font = { color: { argb: "FFEF0000" } };
                  excelCell.numFmt = options.gridCell.column.format;
                }
              } else {
                if (options.gridCell.value == 0) {
                  excelCell.value = "-";
                } else {
                  if (
                    options.gridCell.rowType == "group" &&
                    options.gridCell.groupSummaryItems
                  ) {
                    let pattern = /[%]/g;
                    if (pattern.test(options.gridCell.column.format)) {
                      excelCell.value =
                        options.gridCell.groupSummaryItems[0].value.toFixed(2) +
                        " %";
                    } else {
                      excelCell.numFmt = options.gridCell.column.format;
                      excelCell.value =
                        options.gridCell.groupSummaryItems[0].value;
                    }

                    if (options.gridCell.groupSummaryItems[0].value < 0) {
                      excelCell.font = {
                        color: { argb: "FFEF0000" },
                        bold: true,
                      };
                    } else if (
                      options.gridCell.groupSummaryItems[0].value == 0
                    ) {
                      excelCell.value = "-";
                    }
                  }
                }
              }
            } else {
              if (
                fileName == "Invoiced Sales" &&
                options.gridCell.column.dataField == "DateGroupDisplay"
              ) {
                let groupName = options.gridCell.value.split(":");
                if (groupName.length > 0) {
                  if (groupName.length == 2) {
                    excelCell.value =
                      options.gridCell.column.caption + ": " + groupName[1];
                  } else {
                    let data = groupName[0].match(/.{1,2}/g);
                    if (data.length == 4)
                      excelCell.value =
                        options.gridCell.column.caption +
                        ": " +
                        new Date(
                          data[0].concat(data[1]) +
                            "-" +
                            data[2] +
                            "-" +
                            data[3]
                        ).toShortDateString();
                  }
                }
              }
            }
          },
        }).then(() => {
          worksheet.columns.forEach(function (column) {
            var dataMax = 0;
            column.values.forEach((element) => {
              if (element) {
                var cellLength = element.toString().length;
                if (cellLength > dataMax) dataMax = cellLength;
              }
            });
            column.width = dataMax < 10 ? 10 : dataMax + 5;
          });
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              `${fileName}.xlsx`
            );
          });

          let cols = JSON.parse(this.beforeExportColumns);

          columnNames.forEach((element) => {
            if (element == "Inactive" || element == "FriendlyActive") {
              e.component.columnOption(element, "caption", "");
            } else {
              // e.component.columnOption(element, "visible", false);
              cols.forEach((item) => {
                if (item.dataField == element && !item.cellTemplate)
                  item.visible = false;
              });
            }
          });

          // grid.option("columns", this.beforeExportColumns);
          // grid.repaint(true);
          e.component.option("columns", cols);
          grid.repaint(true);
          e.component.endUpdate();
        });
        e.cancel = true;
      }
    },
    checkFeaturePermission(feature, mode) {
      return FeatureStorage.checkPermission(feature, mode);
    },
    onCellPrepared(e, columnSummary) {
      if (!e.summaryItems) return;
      if (e.rowType == "group" && columnSummary) {
        columnSummary.forEach((element) => {
          let si = e.summaryItems.find(
            (i) => i.showInColumn == element["show-in-column"]
          );
          if (si) {
            let cell = e.cellElement.querySelector(".dx-datagrid-summary-item");
            if (si.value < 0) {
              cell.classList.add("avail-error");
              // var pattern = /[$]/g;
              // if(pattern.test(element['value-format'])){
              //   // cell.innerHTML = "($ " + si.value.toFixed(2).toString().replace(/[-]/, "") + ")";
              // }else{
              //   // cell.innerHTML = "(" + si.value.toFixed(2).toString().replace(/[-]/, "") + ")";
              // }
            } else if (si.value == 0) {
              cell.innerHTML = "-";
            }
          }
        });
      }
    },
    async getCompanyDefaults() {
      await DefaultCompanyBranchDivisionService.getDefault().then(
        async (result) => {
          if (result.data.value.length > 0) {
            await CompanyService.getByCompanyCode(
              result.data.value[0].CompanyCode,
              {
                select: ["CurrencyCode"],
              }
            ).then((res) => {
              this.companyDefaults.currencyCode =
                res.data.value[0].CurrencyCode;
            });
          }
        }
      );
    },
    getLabelWithCurrencyCode(label) {
      return `${label} (${this.companyDefaults.currencyCode})`;
    },
    focusOutOnEditors() {
      var el = document.querySelectorAll("div.dx-form");
      if (el && el.length > 0) {
        el.forEach((element) => {
          var getFormInstance = Form.getInstance(element);
          for (const key in getFormInstance.option().formData) {
            if (getFormInstance.getEditor(key))
              getFormInstance.getEditor(key).blur();
          }
        });
      }
    },
    getSelectFields(columns) {
      var select = [];
      columns.forEach((element) => {
        select.push(element.dataField);
      });

      return select;
    },
  },
};
